// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"594":"7d707e9a","822":"c541c1de"}[chunkId] + ".css";
};